(function () {
  'use strict';
  // REQUIRED for live batches: replace the empty string with your trusted Apps Script /exec URL.
  const FEED_URL = 'https://script.google.com/macros/s/AKfycbzJt-ztfwveaqF36PfcPHZBCkCZJANkO3RIF3QTutSh4LYtes3LF3lBYUQ98qhSeDRQfQ/exec';
  // Keep this list in sync with REPORT_HOSTS in Code.gs.
  const REPORT_HOSTS = ['cdn.shopify.com', 'drive.google.com', 'docs.google.com'];
  const root = document.getElementById('arcanna-labs');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const el = id => root.querySelector('#' + id);
  const norm = value => String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const matches = (text, query) => norm(query).split(' ').filter(Boolean).every(term => norm(text).includes(term));
  const addOption = (select, value) => { const option = document.createElement('option'); option.value = value; option.textContent = value; select.appendChild(option); };
  // Archive controls are optional: removing the archive must not stop batch lookup.
  if (['ac-archive-search', 'ac-archive-category', 'ac-archive-tools', 'ac-archive-count', 'ac-archive-clear'].every(id => el(id))) {
  const groups = Array.from(root.querySelectorAll('.ac-group'));
  const archiveSearch = el('ac-archive-search'), archiveCategory = el('ac-archive-category');
  groups.filter(group => group.querySelector('.ac-report')).forEach(group => addOption(archiveCategory, group.dataset.category));
  function filterArchive() {
    let visible = 0;
    groups.forEach(group => {
      const category = group.dataset.category;
      let groupVisible = 0;
      group.querySelectorAll('.ac-report').forEach(report => {
        const show = (!archiveCategory.value || archiveCategory.value === category) && matches(report.textContent + ' ' + category + (/^(GREENHOUSE|INDOOR|SNOWBALL)/.test(category) ? ' Flower' : ''), archiveSearch.value);
        report.hidden = !show;
        if (show) { visible += report.querySelectorAll('a[href]').length; groupVisible++; }
      });
      // Preserve sections containing explanatory notes but no links when browsing all.
      group.hidden = !groupVisible && !(!archiveSearch.value && !archiveCategory.value && group.querySelector('.ac-note'));
    });
    el('ac-archive-count').textContent = visible ? visible + ' report links shown.' : 'No matching reports. Try fewer words or clear the filters.';
  }
  el('ac-archive-tools').hidden = false;
  archiveSearch.addEventListener('input', filterArchive);
  archiveCategory.addEventListener('change', filterArchive);
  el('ac-archive-clear').addEventListener('click', () => { archiveSearch.value = ''; archiveCategory.value = ''; filterArchive(); archiveSearch.focus(); });
  filterArchive();
  }
  let rows = [], limit = 24, loading = false;
  const search = el('ac-batch-search'), category = el('ac-batch-category'), status = el('ac-feed-status');
  function safeURL(value) {
    try { const u = new URL(value); return u.protocol === 'https:' && !u.username && !u.password && !u.port && REPORT_HOSTS.includes(u.hostname) ? u.href : null; } catch (_) { return null; }
  }
  function validate(payload) {
    if (!payload || payload.ok !== true || payload.version !== 1 || !Array.isArray(payload.rows) || payload.rows.length > 5000) throw new Error('Invalid feed');
    return payload.rows.map(source => {
      if (!source || typeof source !== 'object') throw new Error('Invalid row');
      // Older feeds omit these fields; blank values are valid.
      const row = Object.assign({main_cannabinoid:'', manufacture_date:'', expiration_date:'', report_url:'', tested_on:''}, source);
      if (!row || ['batch_id','main_cannabinoid','product','category','manufacture_date','expiration_date','report_url','tested_on'].some(key => typeof row[key] !== 'string' || row[key].length > (key === 'report_url' ? 2000 : 240))) throw new Error('Invalid row');
      if (!row.batch_id.trim() || !row.product.trim() || (row.report_url && !safeURL(row.report_url))) throw new Error('Invalid report');
      return row;
    });
  }
  function renderBatches(reset) {
    if (reset) limit = 24;
    const filtered = rows.filter(row => (!category.value || row.category === category.value) && matches(row.batch_id + ' ' + row.product + ' ' + row.category + ' ' + row.main_cannabinoid, search.value));
    const container = el('ac-batch-results'); container.replaceChildren();
    filtered.slice(0, limit).forEach(row => {
      const card = document.createElement('article'); card.className = 'ac-batch';
      const badge = document.createElement('div'); badge.className = 'ac-batch-id'; badge.textContent = 'Batch ' + row.batch_id;
      const heading = document.createElement('h3'); heading.textContent = row.product;
      card.append(badge, heading);
      const details = [['Main Cannabinoid', row.main_cannabinoid], ['Category', row.category], ['Manufactured', row.manufacture_date], ['Expires', row.expiration_date], ['Tested', row.tested_on]];
      details.forEach(([label, value]) => {
        if (!value) return;
        const detail = document.createElement('p'); detail.textContent = label + ': ' + value; card.appendChild(detail);
      });
      if (row.report_url) {
        const link = document.createElement('a'); link.textContent = 'View lab report'; link.href = safeURL(row.report_url); link.target = '_blank'; link.rel = 'noopener noreferrer'; link.setAttribute('aria-label', 'View lab report for ' + row.product + ', batch ' + row.batch_id + ' (opens in a new tab)');
        card.appendChild(link);
      } else {
        const note = document.createElement('p'); note.className = 'ac-status'; note.textContent = 'No lab report available for this batch.'; card.appendChild(note);
      }
      container.appendChild(card);
    });
    el('ac-batch-count').textContent = filtered.length ? 'Showing ' + Math.min(limit, filtered.length) + ' of ' + filtered.length + ' matching batches.' : (rows.length ? 'No matching batches. Check your package number, clear the filters, or try the archive below.' : 'No batches have been published yet. Browse the archive below.');
    el('ac-more').hidden = filtered.length <= limit;
  }
  search.addEventListener('input', () => renderBatches(true)); category.addEventListener('change', () => renderBatches(true));
  el('ac-batch-clear').addEventListener('click', () => { search.value = ''; category.value = ''; renderBatches(true); search.focus(); });
  el('ac-more').addEventListener('click', () => { limit += 24; renderBatches(false); });
  function loadFeed() {
    if (loading || !FEED_URL) return;
    let url;
    try { url = new URL(FEED_URL); if (url.origin !== 'https://script.google.com' || !/^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(url.pathname) || url.search || url.hash) throw new Error('Invalid endpoint'); }
    catch (_) { status.textContent = 'Batch lookup is unavailable. Please use the archive below or call 843-420-1308.'; return; }
    loading = true; status.textContent = 'Loading the batch directory…'; el('ac-retry').hidden = true;
    const bytes = new Uint8Array(12); crypto.getRandomValues(bytes);
    const callback = 'arcannaFeed_' + Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    const script = document.createElement('script'); let done = false;
    const cleanup = () => { done = true; loading = false; clearTimeout(timer); script.remove(); window[callback] = () => {}; setTimeout(() => { delete window[callback]; }, 60000); };
    const fail = () => { if (done) return; cleanup(); status.textContent = 'The batch directory could not be loaded. Retry, browse the archive below, or call 843-420-1308.'; el('ac-retry').hidden = false; };
    const timer = setTimeout(fail, 15000);
    window[callback] = payload => {
      if (done) return;
      try {
        const validated = validate(payload);
        // Current batches first, then OLD- batches; descending IDs within each group.
        rows = validated.sort((a, b) => {
          const aOld = /^OLD-/i.test(a.batch_id.trim());
          const bOld = /^OLD-/i.test(b.batch_id.trim());
          if (aOld !== bOld) return aOld ? 1 : -1;
          const aID = a.batch_id.trim().replace(/^OLD-/i, '');
          const bID = b.batch_id.trim().replace(/^OLD-/i, '');
          return bID.localeCompare(aID, 'en', {numeric: true, sensitivity: 'base'});
        });
        cleanup();
        category.replaceChildren(); addOption(category, ''); category.firstElementChild.textContent = 'All categories';
        [...new Set(rows.map(row => row.category).filter(Boolean))].sort().forEach(value => addOption(category, value));
        el('ac-batch-tools').hidden = false;
        status.textContent = 'Search the published batch directory. Reports open in a new tab.';
        renderBatches(true);
      } catch (_) { fail(); }
    };
    url.searchParams.set('callback', callback);
    script.src = url.href; script.async = true; script.referrerPolicy = 'no-referrer'; script.onerror = fail;
    document.head.appendChild(script);
  }
  el('ac-retry').addEventListener('click', loadFeed);
  loadFeed();
}());
